// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-calendar {
  /* width: 400px; */
  max-width: 100%;
  max-width: 100%;
  width: 100%;
  background-color: #fff;
  color: #222;
  border-radius: 8px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  font-family: Arial, Helvetica, sans-serif;
  line-height: 1.125em;
}
.react-calendar__navigation button {
  color: #6f48eb;
  min-width: 44px;
  background: none;
  font-size: 16px;
  margin-top: 8px;
}
.react-calendar__navigation button:enabled:hover,
.react-calendar__navigation button:enabled:focus {
  background-color: #f8f8fa;
}
.react-calendar__navigation button[disabled] {
  background-color: #f0f0f0;
}
abbr[title] {
  text-decoration: none;
}
.holiday {
  color: #fff !important;
  background-color: #44986f;
}

.react-calendar__month-view__days__day--weekend {
  color: #6f48eb;
  /* background-color: orange; */
}
.react-calendar__tile:enabled:hover,
.react-calendar__tile:enabled:focus {
  background: #c8dbf7;
  color: #000000;
  border-radius: 0px;
  border: 1px solid #9ec5fe;
}

.unmarked-working-day {
  color: #000000;
}
.react-calendar__tile--now {
  background: #6f48eb33;
  border-radius: 0px;
  font-weight: bold;
  color: #6f48eb;
}
.react-calendar__tile--now:enabled:hover,
.react-calendar__tile--now:enabled:focus {
  background: #6f48eb33;
  border-radius: 0px;
  font-weight: bold;
  color: #6f48eb;
}
.react-calendar__tile--hasActive:enabled:hover,
.react-calendar__tile--hasActive:enabled:focus {
  background: #3ca8e8;
}
.react-calendar__tile--active {
  background: #6f48eb;
  border-radius: 6px;
  font-weight: bold;
  color: white;
}
.react-calendar__tile--active:enabled:hover,
.react-calendar__tile--active:enabled:focus {
  background: #6f48eb;
  color: white;
}
.react-calendar--selectRange .react-calendar__tile--hover {
  background-color: #f8f8fa;
}
.react-calendar__tile--range {
  background: #f8f8fa;
  color: #6f48eb;
  border-radius: 0;
}
.react-calendar__tile--rangeStart {
  /* border-top-right-radius: 0;
  border-bottom-right-radius: 0; */
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  background: #6f48eb;
  color: white;
}
.react-calendar__tile--rangeEnd {
  border-radius: 0px;
  background: #6f48eb;
  color: white;
}

.react-calendar__navigation button {
  color: #ffffff;
  min-width: 44px;
  /* background-color: #6f48eb; */
  font-size: 16px;
  margin-top: 0px;
  border: 0px !important;
}
.react-calendar {
  max-width: 100%;
  max-width: 100%;
  width: 100%;
  background-color: #fff;
  color: #222;
  border-radius: 0px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  font-family: Arial, Helvetica, sans-serif;
  line-height: 1.125em;
}
.react-calendar__navigation button:enabled:hover,
.react-calendar__navigation button:enabled:focus {
  background-color: #446daf;
}

.react-calendar button {
  font-weight: bold;
  border: 1px solid #e9e9e9;
}
.react-calendar__navigation {
  margin-bottom: 0px;
  /* background-color: #5e89cc; */
  background-color: #2d3186;
}
.react-calendar__month-view__weekdays {
  border-top: 1px solid #e9e9e9;
  border-bottom: 1px solid #e9e9e9;
}
.react-calendar__month-view .react-calendar__month-view__weekdays__weekday {
  border: 1px solid #e9e9e9;
}

/* For regular Saturdays */
.react-calendar__month-view__days__day--weekend.holiday {
  color: #6f48eb;
  background-color: orange;
}

/* For the first four Saturdays of each month */
.react-calendar__month-view__days__day--weekend.first-four-saturdays-holiday {
  color: #ffffff; /* Text color for holidays */
  background-color: orange; /* Background color for holidays */
}
.last-saturday {
  /* background-color: #3ca8e8; */
  background-color: #425c96 !important;
  color: #fff;
}
.holiday-tooltip {
  cursor: pointer; /* Show cursor as pointer when hovering */
}
.attendance-date {
  background-color: #425c96 !important;
  color: white !important;
}

.selected-disabled-date {
  background-color: #ffcccc; /* Light red */
}
.regularization-request {
  /* background-color: rgb(29, 197, 13); */
  color: white; /* Optionally change text color */
}
.regularized {
  background-color: orange;
  color: white;
}
/* .leave-date {
  background-color: rgb(29, 197, 13) !important;
  color: white !important;
} */
/* .leave-request {
  background-color: red !important;
  color: white;
} */

.custom-badges1 {
  background-color: #425c96 !important ;
  color: #000;
}
.custom-badges2 {
  background-color: #58b1d2 !important;
  color: #000;
}
.custom-badges3 {
  background-color: red !important;
  color: #000;
}
.custom-badges4 {
  background-color: rgb(29, 197, 13) !important;
  color: #000;
}
.custom-badges5 {
  background-color: orange !important;
  color: #000;
}
.custom-badges6 {
  background-color: brown !important;
  color: #fff;
}
.custom-badges7 {
  background-color: #58b1d2 !important;
  color: #000;
  border: 1px solid #dacfcf;
}
.dashboards {
  /* display: flex; */
  gap: 20px;
  padding: 20px;
}

.time-section,
.overview-section {
  /* background-color: #f7faff; */
  box-shadow:
    0 5px 15px rgb(2 14 21 / 20%),
    0 10px 20px rgb(22 2 2 / 15%);
  border-radius: 0px;
  padding: 20px;
  /* text-align: center; */
  background-color: #ffffff;
}

.time-section h1 {
  font-size: 2.5em;
  margin-bottom: 10px;
}

.clock-in,
.clock-out {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1em;
  margin-top: 10px;
  color: white;
}

.clock-in {
  background-color: #6c90ff;
}

.clock-out {
  background-color: #ff6b6b;
}

.overview-section h2 {
  font-size: 1.5em;
  margin-bottom: 15px;
}

.overview-stats {
  display: flex;
  justify-content: space-around;
}

.stat {
  text-align: center;
}

.stat .number {
  font-size: 1.5em;
  display: block;
  padding: 10px;
  border-radius: 8px;
  background-color: #6db8d5;
  color: #f0f0f0;
}

.stat .present {
  background-color: #425c96;
  color: #fff;
}
.stat .absent {
  background-color: brown;
  color: #fff;
}
.stat .half {
  background-color: rgb(29, 197, 13);
  color: #fff;
}
.stat .late {
  background-color: #ffe5e5;
  color: #ff6b6b;
}
.stat .lates {
  background-color: red;
  color: #fff;
}
.stat .holidays {
  background-color: #58b1d2;
  color: #fff;
}
.react-calendar__tile.leave-date,
.attendance_page .react-calendar__tile.leave-date,
.react-calendar .react-calendar__tile.leave-date,
.attendance_page .react-calendar__tile.leave-date:enabled:hover,
.attendance_page .react-calendar__tile.leave-date:enabled:focus,
.attendance_page .react-calendar__tile--active.leave-date,
.react-calendar .react-calendar__tile.leave-date:enabled:hover,
.react-calendar .react-calendar__tile.leave-date:enabled:focus,
.react-calendar .react-calendar__tile--active.leave-date {
  background-color: #ff6933 !important;
  border-color: #ff6933 !important;
  color: #fff !important;
}
.unmarked-working-day {
  /* background-color: #81b2d9 !important ; */
  background-color: #e000ad !important;
  border-color: #e000ad;
  color: white;
}
.working-saturday {
  background-color: #d3f9d8; /* Light green or any color you prefer */
}

.overview-section .alert {
  border-radius: 0px;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 0;
}

.overviewCol {
  padding-bottom: 20px;
}
.overviewCol strong {
  font-size: 14px;
  font-weight: 500;
  color: #282833;
}

.overviewSection .col {
  margin-bottom: 20px;
}

.widget_BG {
  background-color: #fff;
  width: 100%;
  display: block;
  height: 100%;
  padding: 20px;
  border: 1px solid #dfe3e9;
}
.widget_BG h3 {
  color: #454e59;
  font-weight: 600;
  font-size: 18px;
  padding: 0px;
  margin: 0px;
}
.widget_BG h4 {
  color: #454e59;
  font-weight: 600;
  font-size: 16px;
  padding: 0px;
  margin: 0px;
}
.widget_BG_grid {
  display: inline-grid;
  align-items: center;
}
.border_radius {
  border-radius: 0px;
}
.markAttendance_btn_color {
  background-color: #8bcfb6;
  border-color: #5abb97;
  color: #fff;
}
.regularize_attendance {
  background-color: #4ccf9f;
  border-color: #39b185;
  color: #fff;
}
.markAttendance_btn_color:hover {
  background-color: #81b2d9;
  border-color: #669ac4;
  color: #fff;
}
.overviewCol strong {
  background-color: #2d3186;
  display: block;
  padding: 5px;
  color: #fff;
}

.overview-section .alert-primary {
  /* background-color: #a0c5e3;
  border-color: #83b5dd; */
  background-color: #81d0ff;
  border-color: #81d0ff;
  color: #fff;
}
.overview-section .alert-secondary {
  /* background-color: #81b2d9; */
  background-color: #6366f1;
  border-color: #5154f6;
  color: #fff;
}
.overview-section .alert-success {
  /* background-color: #8bcfb6;
  border-color: #6cb59a; */
  background-color: #10b981;
  border-color: #10b981;
  color: #fff;
}
.overview-section .alert-danger {
  /* background-color: #e39b99;
  border-color: #bd7270; */
  background-color: #e000ad;
  border-color: #e000ad;
  color: #fff;
}
.overview-section .alert-warning {
  /* background-color: #4ccf9f;
  border-color: #39b185; */
  background-color: #ffa71a;
  border-color: #ffa71a;
  color: #fff;
}
.overview-section .alert-info {
  /* background-color: #faa19b;
  border-color: #38bb8b; */
  background-color: #48443d;
  border-color: #48443d;
  color: #fff;
}
.overview-section .alert-light {
  /* background-color: #ff6863;
  border-color: #cd2a2a; */
  background-color: #ff6933;
  border-color: #ff6933;
  color: #fff;
}
.overview-section .alert-dark {
  background-color: #df1a42;
  border-color: #bf0a2f;
  color: #fff;
}

.attendance_page .leave-request,
.react-calendar .react-calendar__tile.leave-request,
.attendance_page .react-calendar__tile.leave-request,
.attendance_page .react-calendar__tile.leave-request:enabled:hover,
.attendance_page .react-calendar__tile.leave-request:enabled:focus,
.react-calendar .react-calendar__tile--active.leave-request {
  /* background-color: #ff6863 !important; */
  background-color: #ff6933 !important;
  border-color: #fff !important;
  color: #fff !important;
}

.attendance_page .react-calendar__tile:disabled {
  background-color: #df1a42;
  color: #ffffff;
}

.attendance_page .attendance-date {
  /* background-color: #89cdb4 !important; */
  background-color: #10b981 !important;
  color: white !important;
}

.attendance_page .future-date {
  /* background-color: #89cdb4 !important; */
  background-color: #81d0ff !important;
  color: white !important;
}

.attendance_page .absent-date,
.react-calendar .react-calendar__tile.absent-date {
  background-color: #e000ad !important;
  border-color: #e000ad !important;
  color: #ffffff !important;
}

.attendance_page .regularized,
.react-calendar .react-calendar__tile.regularized {
  background-color: #ffa71a !important;
  /* border-color: #ffa71a !important; */
  color: #ffffff !important;
}

.attendance_page .compoff-date,
.react-calendar .react-calendar__tile.compoff-date,
.react-calendar .react-calendar__tile.compoff-date:enabled:hover,
.react-calendar .react-calendar__tile.compoff-date:enabled:focus {
  background-color: #9b59b6 !important;
  border-color: #9b59b6 !important;
  color: #ffffff !important;
}

.Toastify__toast-theme--colored.Toastify__toast--success {
  background: #a0c5e3;
}

.react-calendar__tile:disabled {
  background-color: #a0c5e3;
  color: #ffffff;
}

.react-calendar__navigation button[disabled] {
  background-color: #90addb;
}

.react-calendar__tile--rangeEnd {
  background-color: #4ccf9f;
  border-color: #4ccf9f;
  color: #fff;
}

.Toastify__toast-theme--colored.Toastify__toast--warning {
  background-color: #faa19b !important;
}
.react-calendar .react-calendar__tile.late-attendance {
  background-color: #48443d !important;
  border-color: #f3f1ee;
  color: #ffffff !important;
}

/* Optional: Add "L" marker for late attendance */
.react-calendar__tile.late-attendance::after {
  /* content: "L"; */
  position: absolute;
  top: 2px;
  right: 2px;
  font-size: 8px;
  font-weight: bold;
  color: #ffffff;
  background-color: rgba(255, 255, 255, 0.2);
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/Sidebar/AttendencePage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,yCAAyC;EACzC,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;AACA;;EAEE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;AACA;;EAEE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;kCACgC;EAChC,2BAA2B;EAC3B,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,yCAAyC;EACzC,oBAAoB;AACtB;AACA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA,+CAA+C;AAC/C;EACE,cAAc,EAAE,4BAA4B;EAC5C,wBAAwB,EAAE,kCAAkC;AAC9D;AACA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,eAAe,EAAE,yCAAyC;AAC5D;AACA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB,EAAE,cAAc;AAC3C;AACA;EACE,wCAAwC;EACxC,YAAY,EAAE,iCAAiC;AACjD;AACA;EACE,wBAAwB;EACxB,YAAY;AACd;AACA;;;GAGG;AACH;;;GAGG;;AAEH;EACE,qCAAqC;EACrC,WAAW;AACb;AACA;EACE,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,6CAA6C;EAC7C,WAAW;AACb;AACA;EACE,mCAAmC;EACnC,WAAW;AACb;AACA;EACE,kCAAkC;EAClC,WAAW;AACb;AACA;EACE,oCAAoC;EACpC,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;;EAEE,+BAA+B;EAC/B;;iCAE+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,kCAAkC;EAClC,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;;;;;;;;;EASE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,2CAA2C;EAC3C,oCAAoC;EACpC,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,yBAAyB,EAAE,wCAAwC;AACrE;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;0BACwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE;0BACwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE;0BACwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE;0BACwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE;0BACwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE;0BACwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;;;;EAME,0CAA0C;EAC1C,oCAAoC;EACpC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;;;;EAIE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,0CAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".react-calendar {\r\n  /* width: 400px; */\r\n  max-width: 100%;\r\n  max-width: 100%;\r\n  width: 100%;\r\n  background-color: #fff;\r\n  color: #222;\r\n  border-radius: 8px;\r\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);\r\n  font-family: Arial, Helvetica, sans-serif;\r\n  line-height: 1.125em;\r\n}\r\n.react-calendar__navigation button {\r\n  color: #6f48eb;\r\n  min-width: 44px;\r\n  background: none;\r\n  font-size: 16px;\r\n  margin-top: 8px;\r\n}\r\n.react-calendar__navigation button:enabled:hover,\r\n.react-calendar__navigation button:enabled:focus {\r\n  background-color: #f8f8fa;\r\n}\r\n.react-calendar__navigation button[disabled] {\r\n  background-color: #f0f0f0;\r\n}\r\nabbr[title] {\r\n  text-decoration: none;\r\n}\r\n.holiday {\r\n  color: #fff !important;\r\n  background-color: #44986f;\r\n}\r\n\r\n.react-calendar__month-view__days__day--weekend {\r\n  color: #6f48eb;\r\n  /* background-color: orange; */\r\n}\r\n.react-calendar__tile:enabled:hover,\r\n.react-calendar__tile:enabled:focus {\r\n  background: #c8dbf7;\r\n  color: #000000;\r\n  border-radius: 0px;\r\n  border: 1px solid #9ec5fe;\r\n}\r\n\r\n.unmarked-working-day {\r\n  color: #000000;\r\n}\r\n.react-calendar__tile--now {\r\n  background: #6f48eb33;\r\n  border-radius: 0px;\r\n  font-weight: bold;\r\n  color: #6f48eb;\r\n}\r\n.react-calendar__tile--now:enabled:hover,\r\n.react-calendar__tile--now:enabled:focus {\r\n  background: #6f48eb33;\r\n  border-radius: 0px;\r\n  font-weight: bold;\r\n  color: #6f48eb;\r\n}\r\n.react-calendar__tile--hasActive:enabled:hover,\r\n.react-calendar__tile--hasActive:enabled:focus {\r\n  background: #3ca8e8;\r\n}\r\n.react-calendar__tile--active {\r\n  background: #6f48eb;\r\n  border-radius: 6px;\r\n  font-weight: bold;\r\n  color: white;\r\n}\r\n.react-calendar__tile--active:enabled:hover,\r\n.react-calendar__tile--active:enabled:focus {\r\n  background: #6f48eb;\r\n  color: white;\r\n}\r\n.react-calendar--selectRange .react-calendar__tile--hover {\r\n  background-color: #f8f8fa;\r\n}\r\n.react-calendar__tile--range {\r\n  background: #f8f8fa;\r\n  color: #6f48eb;\r\n  border-radius: 0;\r\n}\r\n.react-calendar__tile--rangeStart {\r\n  /* border-top-right-radius: 0;\r\n  border-bottom-right-radius: 0; */\r\n  border-top-left-radius: 6px;\r\n  border-bottom-left-radius: 6px;\r\n  background: #6f48eb;\r\n  color: white;\r\n}\r\n.react-calendar__tile--rangeEnd {\r\n  border-radius: 0px;\r\n  background: #6f48eb;\r\n  color: white;\r\n}\r\n\r\n.react-calendar__navigation button {\r\n  color: #ffffff;\r\n  min-width: 44px;\r\n  /* background-color: #6f48eb; */\r\n  font-size: 16px;\r\n  margin-top: 0px;\r\n  border: 0px !important;\r\n}\r\n.react-calendar {\r\n  max-width: 100%;\r\n  max-width: 100%;\r\n  width: 100%;\r\n  background-color: #fff;\r\n  color: #222;\r\n  border-radius: 0px;\r\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);\r\n  font-family: Arial, Helvetica, sans-serif;\r\n  line-height: 1.125em;\r\n}\r\n.react-calendar__navigation button:enabled:hover,\r\n.react-calendar__navigation button:enabled:focus {\r\n  background-color: #446daf;\r\n}\r\n\r\n.react-calendar button {\r\n  font-weight: bold;\r\n  border: 1px solid #e9e9e9;\r\n}\r\n.react-calendar__navigation {\r\n  margin-bottom: 0px;\r\n  /* background-color: #5e89cc; */\r\n  background-color: #2d3186;\r\n}\r\n.react-calendar__month-view__weekdays {\r\n  border-top: 1px solid #e9e9e9;\r\n  border-bottom: 1px solid #e9e9e9;\r\n}\r\n.react-calendar__month-view .react-calendar__month-view__weekdays__weekday {\r\n  border: 1px solid #e9e9e9;\r\n}\r\n\r\n/* For regular Saturdays */\r\n.react-calendar__month-view__days__day--weekend.holiday {\r\n  color: #6f48eb;\r\n  background-color: orange;\r\n}\r\n\r\n/* For the first four Saturdays of each month */\r\n.react-calendar__month-view__days__day--weekend.first-four-saturdays-holiday {\r\n  color: #ffffff; /* Text color for holidays */\r\n  background-color: orange; /* Background color for holidays */\r\n}\r\n.last-saturday {\r\n  /* background-color: #3ca8e8; */\r\n  background-color: #425c96 !important;\r\n  color: #fff;\r\n}\r\n.holiday-tooltip {\r\n  cursor: pointer; /* Show cursor as pointer when hovering */\r\n}\r\n.attendance-date {\r\n  background-color: #425c96 !important;\r\n  color: white !important;\r\n}\r\n\r\n.selected-disabled-date {\r\n  background-color: #ffcccc; /* Light red */\r\n}\r\n.regularization-request {\r\n  /* background-color: rgb(29, 197, 13); */\r\n  color: white; /* Optionally change text color */\r\n}\r\n.regularized {\r\n  background-color: orange;\r\n  color: white;\r\n}\r\n/* .leave-date {\r\n  background-color: rgb(29, 197, 13) !important;\r\n  color: white !important;\r\n} */\r\n/* .leave-request {\r\n  background-color: red !important;\r\n  color: white;\r\n} */\r\n\r\n.custom-badges1 {\r\n  background-color: #425c96 !important ;\r\n  color: #000;\r\n}\r\n.custom-badges2 {\r\n  background-color: #58b1d2 !important;\r\n  color: #000;\r\n}\r\n.custom-badges3 {\r\n  background-color: red !important;\r\n  color: #000;\r\n}\r\n.custom-badges4 {\r\n  background-color: rgb(29, 197, 13) !important;\r\n  color: #000;\r\n}\r\n.custom-badges5 {\r\n  background-color: orange !important;\r\n  color: #000;\r\n}\r\n.custom-badges6 {\r\n  background-color: brown !important;\r\n  color: #fff;\r\n}\r\n.custom-badges7 {\r\n  background-color: #58b1d2 !important;\r\n  color: #000;\r\n  border: 1px solid #dacfcf;\r\n}\r\n.dashboards {\r\n  /* display: flex; */\r\n  gap: 20px;\r\n  padding: 20px;\r\n}\r\n\r\n.time-section,\r\n.overview-section {\r\n  /* background-color: #f7faff; */\r\n  box-shadow:\r\n    0 5px 15px rgb(2 14 21 / 20%),\r\n    0 10px 20px rgb(22 2 2 / 15%);\r\n  border-radius: 0px;\r\n  padding: 20px;\r\n  /* text-align: center; */\r\n  background-color: #ffffff;\r\n}\r\n\r\n.time-section h1 {\r\n  font-size: 2.5em;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.clock-in,\r\n.clock-out {\r\n  padding: 10px 20px;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  font-size: 1em;\r\n  margin-top: 10px;\r\n  color: white;\r\n}\r\n\r\n.clock-in {\r\n  background-color: #6c90ff;\r\n}\r\n\r\n.clock-out {\r\n  background-color: #ff6b6b;\r\n}\r\n\r\n.overview-section h2 {\r\n  font-size: 1.5em;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.overview-stats {\r\n  display: flex;\r\n  justify-content: space-around;\r\n}\r\n\r\n.stat {\r\n  text-align: center;\r\n}\r\n\r\n.stat .number {\r\n  font-size: 1.5em;\r\n  display: block;\r\n  padding: 10px;\r\n  border-radius: 8px;\r\n  background-color: #6db8d5;\r\n  color: #f0f0f0;\r\n}\r\n\r\n.stat .present {\r\n  background-color: #425c96;\r\n  color: #fff;\r\n}\r\n.stat .absent {\r\n  background-color: brown;\r\n  color: #fff;\r\n}\r\n.stat .half {\r\n  background-color: rgb(29, 197, 13);\r\n  color: #fff;\r\n}\r\n.stat .late {\r\n  background-color: #ffe5e5;\r\n  color: #ff6b6b;\r\n}\r\n.stat .lates {\r\n  background-color: red;\r\n  color: #fff;\r\n}\r\n.stat .holidays {\r\n  background-color: #58b1d2;\r\n  color: #fff;\r\n}\r\n.react-calendar__tile.leave-date,\r\n.attendance_page .react-calendar__tile.leave-date,\r\n.react-calendar .react-calendar__tile.leave-date,\r\n.attendance_page .react-calendar__tile.leave-date:enabled:hover,\r\n.attendance_page .react-calendar__tile.leave-date:enabled:focus,\r\n.attendance_page .react-calendar__tile--active.leave-date,\r\n.react-calendar .react-calendar__tile.leave-date:enabled:hover,\r\n.react-calendar .react-calendar__tile.leave-date:enabled:focus,\r\n.react-calendar .react-calendar__tile--active.leave-date {\r\n  background-color: #ff6933 !important;\r\n  border-color: #ff6933 !important;\r\n  color: #fff !important;\r\n}\r\n.unmarked-working-day {\r\n  /* background-color: #81b2d9 !important ; */\r\n  background-color: #e000ad !important;\r\n  border-color: #e000ad;\r\n  color: white;\r\n}\r\n.working-saturday {\r\n  background-color: #d3f9d8; /* Light green or any color you prefer */\r\n}\r\n\r\n.overview-section .alert {\r\n  border-radius: 0px;\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.overviewCol {\r\n  padding-bottom: 20px;\r\n}\r\n.overviewCol strong {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #282833;\r\n}\r\n\r\n.overviewSection .col {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.widget_BG {\r\n  background-color: #fff;\r\n  width: 100%;\r\n  display: block;\r\n  height: 100%;\r\n  padding: 20px;\r\n  border: 1px solid #dfe3e9;\r\n}\r\n.widget_BG h3 {\r\n  color: #454e59;\r\n  font-weight: 600;\r\n  font-size: 18px;\r\n  padding: 0px;\r\n  margin: 0px;\r\n}\r\n.widget_BG h4 {\r\n  color: #454e59;\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n  padding: 0px;\r\n  margin: 0px;\r\n}\r\n.widget_BG_grid {\r\n  display: inline-grid;\r\n  align-items: center;\r\n}\r\n.border_radius {\r\n  border-radius: 0px;\r\n}\r\n.markAttendance_btn_color {\r\n  background-color: #8bcfb6;\r\n  border-color: #5abb97;\r\n  color: #fff;\r\n}\r\n.regularize_attendance {\r\n  background-color: #4ccf9f;\r\n  border-color: #39b185;\r\n  color: #fff;\r\n}\r\n.markAttendance_btn_color:hover {\r\n  background-color: #81b2d9;\r\n  border-color: #669ac4;\r\n  color: #fff;\r\n}\r\n.overviewCol strong {\r\n  background-color: #2d3186;\r\n  display: block;\r\n  padding: 5px;\r\n  color: #fff;\r\n}\r\n\r\n.overview-section .alert-primary {\r\n  /* background-color: #a0c5e3;\r\n  border-color: #83b5dd; */\r\n  background-color: #81d0ff;\r\n  border-color: #81d0ff;\r\n  color: #fff;\r\n}\r\n.overview-section .alert-secondary {\r\n  /* background-color: #81b2d9; */\r\n  background-color: #6366f1;\r\n  border-color: #5154f6;\r\n  color: #fff;\r\n}\r\n.overview-section .alert-success {\r\n  /* background-color: #8bcfb6;\r\n  border-color: #6cb59a; */\r\n  background-color: #10b981;\r\n  border-color: #10b981;\r\n  color: #fff;\r\n}\r\n.overview-section .alert-danger {\r\n  /* background-color: #e39b99;\r\n  border-color: #bd7270; */\r\n  background-color: #e000ad;\r\n  border-color: #e000ad;\r\n  color: #fff;\r\n}\r\n.overview-section .alert-warning {\r\n  /* background-color: #4ccf9f;\r\n  border-color: #39b185; */\r\n  background-color: #ffa71a;\r\n  border-color: #ffa71a;\r\n  color: #fff;\r\n}\r\n.overview-section .alert-info {\r\n  /* background-color: #faa19b;\r\n  border-color: #38bb8b; */\r\n  background-color: #48443d;\r\n  border-color: #48443d;\r\n  color: #fff;\r\n}\r\n.overview-section .alert-light {\r\n  /* background-color: #ff6863;\r\n  border-color: #cd2a2a; */\r\n  background-color: #ff6933;\r\n  border-color: #ff6933;\r\n  color: #fff;\r\n}\r\n.overview-section .alert-dark {\r\n  background-color: #df1a42;\r\n  border-color: #bf0a2f;\r\n  color: #fff;\r\n}\r\n\r\n.attendance_page .leave-request,\r\n.react-calendar .react-calendar__tile.leave-request,\r\n.attendance_page .react-calendar__tile.leave-request,\r\n.attendance_page .react-calendar__tile.leave-request:enabled:hover,\r\n.attendance_page .react-calendar__tile.leave-request:enabled:focus,\r\n.react-calendar .react-calendar__tile--active.leave-request {\r\n  /* background-color: #ff6863 !important; */\r\n  background-color: #ff6933 !important;\r\n  border-color: #fff !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.attendance_page .react-calendar__tile:disabled {\r\n  background-color: #df1a42;\r\n  color: #ffffff;\r\n}\r\n\r\n.attendance_page .attendance-date {\r\n  /* background-color: #89cdb4 !important; */\r\n  background-color: #10b981 !important;\r\n  color: white !important;\r\n}\r\n\r\n.attendance_page .future-date {\r\n  /* background-color: #89cdb4 !important; */\r\n  background-color: #81d0ff !important;\r\n  color: white !important;\r\n}\r\n\r\n.attendance_page .absent-date,\r\n.react-calendar .react-calendar__tile.absent-date {\r\n  background-color: #e000ad !important;\r\n  border-color: #e000ad !important;\r\n  color: #ffffff !important;\r\n}\r\n\r\n.attendance_page .regularized,\r\n.react-calendar .react-calendar__tile.regularized {\r\n  background-color: #ffa71a !important;\r\n  /* border-color: #ffa71a !important; */\r\n  color: #ffffff !important;\r\n}\r\n\r\n.attendance_page .compoff-date,\r\n.react-calendar .react-calendar__tile.compoff-date,\r\n.react-calendar .react-calendar__tile.compoff-date:enabled:hover,\r\n.react-calendar .react-calendar__tile.compoff-date:enabled:focus {\r\n  background-color: #9b59b6 !important;\r\n  border-color: #9b59b6 !important;\r\n  color: #ffffff !important;\r\n}\r\n\r\n.Toastify__toast-theme--colored.Toastify__toast--success {\r\n  background: #a0c5e3;\r\n}\r\n\r\n.react-calendar__tile:disabled {\r\n  background-color: #a0c5e3;\r\n  color: #ffffff;\r\n}\r\n\r\n.react-calendar__navigation button[disabled] {\r\n  background-color: #90addb;\r\n}\r\n\r\n.react-calendar__tile--rangeEnd {\r\n  background-color: #4ccf9f;\r\n  border-color: #4ccf9f;\r\n  color: #fff;\r\n}\r\n\r\n.Toastify__toast-theme--colored.Toastify__toast--warning {\r\n  background-color: #faa19b !important;\r\n}\r\n.react-calendar .react-calendar__tile.late-attendance {\r\n  background-color: #48443d !important;\r\n  border-color: #f3f1ee;\r\n  color: #ffffff !important;\r\n}\r\n\r\n/* Optional: Add \"L\" marker for late attendance */\r\n.react-calendar__tile.late-attendance::after {\r\n  /* content: \"L\"; */\r\n  position: absolute;\r\n  top: 2px;\r\n  right: 2px;\r\n  font-size: 8px;\r\n  font-weight: bold;\r\n  color: #ffffff;\r\n  background-color: rgba(255, 255, 255, 0.2);\r\n  width: 12px;\r\n  height: 12px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
